exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#topo[data-v-11ad32f2]{position:relative;top:20px;right:0;left:0;font-size:13px;height:40px;max-width:960px;margin:auto}.titulo_paginas[data-v-11ad32f2]{background-color:#253b6d;color:#fff;left:10px;line-height:0;position:absolute;top:0;padding:10px}#topo hr[data-v-11ad32f2]{width:100%;border-top:0;border-left:0;border-right:0;border-bottom:1px solid #253b6d;position:absolute;margin:0;top:19px;z-index:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11ad32f2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/PageTitle.vue
// module id = 1179
// module chunks = 0